import React from "react";
import "./Developertag.css";

export default function Developertag() {
  return (
    <p className="coderTag">
      <a href="https://github.com/Isa-Stein/my-React-weather-app">
        Open-sourced code
      </a>{" "}
      by Isabelle Steinhauslin
    </p>
  );
}
